/* P&S Designs · comportamiento del tema (encabezado, carro lateral, vista rápida, ficha, colección y páginas) */
(() => {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const R = Object.assign(
    { root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change', search: '/search', suggest: '/search/suggest' },
    (window.PYS && window.PYS.routes) || {}
  );
  const root = R.root.endsWith('/') ? R.root : R.root + '/';
  const fmt = (c) => '$' + Math.round(c / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  const store = {
    get(k, d) { try { const v = localStorage.getItem('pys-' + k); return v ? JSON.parse(v) : d; } catch (e) { return d; } },
    set(k, v) { try { localStorage.setItem('pys-' + k, JSON.stringify(v)); } catch (e) {} },
  };
  const parse = (html) => new DOMParser().parseFromString(html, 'text/html');
  const sectionInner = (html) => { const d = parse(html); const s = d.querySelector('.shopify-section'); return s ? s.innerHTML : d.body.innerHTML; };
  const isMob = () => window.matchMedia('(max-width:900px)').matches;

  /* ---------- aviso breve ---------- */
  let toastT;
  function toast(m) {
    const t = $('#toast'); if (!t) return;
    t.textContent = m; t.classList.add('on');
    clearTimeout(toastT); toastT = setTimeout(() => t.classList.remove('on'), 2800);
  }

  /* ---------- paneles laterales ---------- */
  let lastFocus = null;
  function openDrw(id) {
    closeMega(); closeSearch();
    lastFocus = document.activeElement;
    $$('.drw').forEach((d) => d.classList.toggle('on', d.id === id));
    $('#veil')?.classList.add('on');
    document.body.classList.add('lock');
    document.body.style.overflow = 'hidden';
    const top = $('#top'); top && top.classList.remove('hide');
    const d = document.getElementById(id);
    if (d) setTimeout(() => d.focus({ preventScroll: true }), 50);
  }
  function closeAll() {
    $$('.drw').forEach((d) => d.classList.remove('on'));
    $('#veil')?.classList.remove('on');
    document.body.classList.remove('lock');
    document.body.style.overflow = '';
    $('#zoom')?.classList.remove('on');
    if (lastFocus && document.contains(lastFocus)) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
    lastFocus = null;
  }

  /* ---------- encabezado ---------- */
  let lastY = 0;
  function updateTop(force) {
    const t = $('#top'); if (!t) return;
    const y = window.scrollY;
    if (t.dataset.overlay === 'true') t.classList.toggle('at-top', y <= 2);
    if (force) { t.classList.remove('hide'); lastY = y; }
    else if (!document.body.classList.contains('lock')) {
      if (y > lastY + 4 && y > 160 && !t.classList.contains('menu-open')) t.classList.add('hide');
      else if (y < lastY - 4) t.classList.remove('hide');
      lastY = y;
    }
    const vis = !t.classList.contains('hide');
    document.documentElement.style.setProperty('--sticky-off', vis ? t.offsetHeight + 'px' : '0px');
    stickyATC();
  }
  window.addEventListener('scroll', () => updateTop(false), { passive: true });

  let megaT;
  function openMega(k) {
    clearTimeout(megaT);
    const top = $('#top'); if (!top) return;
    $$('.mega', top).forEach((m) => m.classList.toggle('on', m.dataset.mega === String(k)));
    $$('.nav [data-m]', top).forEach((n) => n.classList.toggle('open', n.dataset.m === String(k)));
    top.classList.add('menu-open'); $('#dim')?.classList.add('on'); $('#sdrop')?.classList.remove('on');
  }
  function closeMega() {
    const top = $('#top'); if (!top) return;
    $$('.mega', top).forEach((m) => m.classList.remove('on'));
    $$('.nav [data-m]', top).forEach((n) => n.classList.remove('open'));
    if (!$('#sdrop')?.classList.contains('on')) { top.classList.remove('menu-open'); $('#dim')?.classList.remove('on'); }
  }
  let sAbort, sT;
  function searchDrop(q) {
    q = q.trim(); const d = $('#sdrop'); if (!d) return;
    if (!q) { closeSearch(); return; }
    clearTimeout(sT);
    sT = setTimeout(async () => {
      sAbort?.abort(); sAbort = new AbortController();
      try {
        const u = `${R.suggest}?q=${encodeURIComponent(q)}&section_id=pys-predictive-search&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,tag`;
        const r = await fetch(u, { signal: sAbort.signal });
        if (!r.ok) return;
        d.innerHTML = sectionInner(await r.text());
        d.classList.add('on');
        $$('.mega').forEach((m) => m.classList.remove('on'));
        $('#top')?.classList.add('menu-open'); $('#dim')?.classList.add('on');
        initFavs(d);
      } catch (e) {}
    }, 220);
  }
  function closeSearch() {
    $('#sdrop')?.classList.remove('on');
    if (!$$('.mega.on').length) { $('#top')?.classList.remove('menu-open'); $('#dim')?.classList.remove('on'); }
  }
  function initHeader() {
    const top = $('#top'); if (!top) return;
    $$('.nav>a,.nav>div', top).forEach((el) => {
      el.addEventListener('mouseenter', () => { const k = el.dataset.m; if (k) openMega(k); else closeMega(); });
      el.addEventListener('focusin', () => { const k = el.dataset.m; if (k) openMega(k); else closeMega(); });
    });
    const hdr = $('#hdr', top);
    hdr && hdr.addEventListener('mouseleave', () => { megaT = setTimeout(closeMega, 120); });
    $$('.mega', top).forEach((m) => m.addEventListener('mouseenter', () => clearTimeout(megaT)));
    const sq = $('#sq', top);
    if (sq) {
      sq.addEventListener('input', () => searchDrop(sq.value));
      sq.addEventListener('focus', () => { if (sq.value) searchDrop(sq.value); });
    }
    initRotators(top);
    updateTop(true);
  }
  function initRotators(scope) {
    $$('[data-rot]', scope).forEach((r) => {
      clearInterval(r._t);
      const sp = $$(':scope>span', r); if (!sp.length) return;
      let i = 0; sp.forEach((s, k) => s.classList.toggle('on', k === 0));
      if (sp.length > 1) r._t = setInterval(() => { sp[i].classList.remove('on'); i = (i + 1) % sp.length; sp[i].classList.add('on'); }, 4500);
    });
  }
  function openMM() {
    const tpl = $('#mm-tpl'); const mm = $('#mm'); if (!tpl || !mm) return;
    mm.innerHTML = ''; mm.appendChild(tpl.content.cloneNode(true));
    openDrw('mm');
  }

  /* ---------- favoritos ---------- */
  let favs = store.get('favs', []);
  const isFav = (h) => favs.includes(h);
  function favBadge() { const f = $('#fav-n'); if (f) { f.hidden = !favs.length; f.textContent = favs.length; } }
  function initFavs(scope = document) {
    $$('[data-fav]', scope).forEach((b) => { const on = isFav(b.dataset.fav); b.classList.toggle('on', on); b.setAttribute('aria-pressed', on); });
  }
  function toggleFav(h) {
    favs = isFav(h) ? favs.filter((x) => x !== h) : [...favs, h];
    store.set('favs', favs); initFavs(); favBadge();
    toast(isFav(h) ? 'Guardado en favoritos' : 'Quitado de favoritos');
    const page = $('[data-favs]'); if (page && !isFav(h)) { const c = $(`#fav-grid .card[data-h="${h}"]`); c && c.remove(); favEmpty(); }
  }
  function favEmpty() { const g = $('#fav-grid'), e = $('#fav-empty'); if (g && e) e.hidden = !!g.children.length; }
  async function initFavPage() {
    const page = $('[data-favs]'); if (!page) return;
    const g = $('#fav-grid'); g.innerHTML = '';
    const list = [...favs];
    const html = await Promise.all(list.map((h) => fetch(`${root}products/${encodeURIComponent(h)}?section_id=pys-card-render`).then((r) => (r.ok ? r.text() : null)).catch(() => null)));
    html.forEach((t, i) => {
      if (!t) { favs = favs.filter((x) => x !== list[i]); return; }
      const d = parse(t); const c = d.querySelector('.card'); if (c) g.appendChild(c);
    });
    store.set('favs', favs); favBadge(); initFavs(g); favEmpty();
  }

  /* ---------- carro ---------- */
  const CART_SEC = 'pys-cart-drawer';
  function cartBadge(n) { const c = $('#cart-n'); if (c) { c.hidden = !n; c.textContent = n; } }
  function renderCartSections(sections) {
    if (!sections) return;
    if (sections[CART_SEC]) {
      const dest = $('#cart .shopify-section') || $('#cart');
      dest.innerHTML = sectionInner(sections[CART_SEC]);
      const n = +($('.drw-in', dest)?.dataset.count || 0); cartBadge(n);
      initFavs(dest);
    }
    const page = $('[data-cartpage]');
    if (page) {
      const sec = page.closest('.shopify-section'); const id = sec && sec.id.replace('shopify-section-', '');
      if (id && sections[id]) { sec.innerHTML = sectionInner(sections[id]); initFavs(sec); }
    }
  }
  function cartSectionIds() {
    const ids = [CART_SEC];
    const page = $('[data-cartpage]'); const sec = page && page.closest('.shopify-section');
    if (sec) ids.push(sec.id.replace('shopify-section-', ''));
    return ids;
  }
  async function cartChange(line, quantity) {
    const box = $('#cart .drw-in'); box && box.classList.add('cart-busy');
    const pg = $('[data-cartpage]'); pg && pg.classList.add('cart-busy');
    try {
      const r = await fetch(R.cartChange + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity, sections: cartSectionIds().join(','), sections_url: location.pathname }),
      });
      const j = await r.json();
      if (j.status) { toast(j.description || j.message || 'No pudimos actualizar el carro.'); await refreshCart(); }
      else { renderCartSections(j.sections); cartBadge(j.item_count); }
    } catch (e) { toast('No pudimos actualizar el carro. Inténtalo de nuevo.'); }
    finally { $('#cart .drw-in')?.classList.remove('cart-busy'); $('[data-cartpage]')?.classList.remove('cart-busy'); }
  }
  async function refreshCart() {
    try {
      const r = await fetch(`${root}?sections=${cartSectionIds().join(',')}`);
      if (r.ok) renderCartSections(await r.json());
    } catch (e) {}
  }
  if (!customElements.get('cart-drawer')) {
    customElements.define('cart-drawer', class extends HTMLElement {
      open() { openDrw('cart'); }
      close() { closeAll(); }
      getSectionsToRender() { return [{ id: CART_SEC, selector: '.shopify-section' }]; }
      renderContents(state) { if (state && state.sections) renderCartSections(state.sections); this.open(); }
      setActiveElement() {}
    });
  }
  function initStandardActions() {
    const a = window.Shopify && window.Shopify.actions; if (!a) return;
    try {
      a.openCart && a.openCart.configure({ handler: async () => openDrw('cart') });
      a.updateCart && a.updateCart.configure({
        eventTarget: () => document,
        handler: async (def) => { const res = await def(); await refreshCart(); return res; },
      });
    } catch (e) {}
  }

  /* ---------- producto (ficha y vista rápida) ---------- */
  class PysProduct extends HTMLElement {
    connectedCallback() {
      if (this._ok) return; this._ok = true;
      try { this.d = JSON.parse($('.pjson', this).textContent); } catch (e) { return; }
      this.form = $('form.atc-form', this); if (!this.form) return;
      this.idIn = $('[name=id]', this.form); this.err = $('.atc-err', this); this.btn = $('[data-atc]', this.form);
      this.ci = this.d.opts.findIndex((o) => o.k === 'color');
      this.sel = this.d.opts.map(() => null);
      const init = this.idIn.value && this.d.v.find((v) => String(v.id) === this.idIn.value);
      if (init) this.sel = [...init.o];
      this.d.opts.forEach((o) => { const on = $(`[data-opt="${o.i}"] .on`, this); if (on) this.sel[o.i] = on.dataset.val; });
      if (this.d.need) { const si = this.d.opts.findIndex((o) => o.k === 'size'); if (si > -1 && !$(`[data-opt="${si}"] .on`, this)) this.sel[si] = null; }
      this.addEventListener('click', (e) => {
        const b = e.target.closest('[data-opt] [data-val]');
        if (b && !b.disabled && this.contains(b)) { e.preventDefault(); this.pick(+b.closest('[data-opt]').dataset.opt, b.dataset.val, true); }
      });
      this.form.addEventListener('submit', (e) => { e.preventDefault(); this.add(); });
      this.refresh(false);
    }
    get scope() { return this.closest('[data-pdp]') || this.closest('.qv-wrap') || this.parentElement; }
    variant() {
      if (this.d.v.length === 1 && this.d.opts.every((o) => !$(`[data-opt="${o.i}"]`, this))) return this.d.v[0];
      return this.d.v.find((v) => v.o.every((x, i) => this.sel[i] === x)) || null;
    }
    pick(i, val, user) {
      this.sel[i] = val;
      const g = $(`[data-opt="${i}"]`, this);
      $$('[data-val]', g).forEach((b) => { const on = b.dataset.val === val; b.classList.toggle('on', on); b.setAttribute('aria-checked', on); });
      if (i === this.ci) this.colorChanged(val);
      else { const lab = g.previousElementSibling && $('.oname', g.previousElementSibling); if (lab) lab.textContent = val; }
      if (this.err) this.err.textContent = '';
      this.refresh(user);
    }
    colorChanged(c) {
      const sc = this.scope;
      const lab = $('.cname', this); if (lab) lab.textContent = c;
      const any = this.d.v.find((v) => v.o[this.ci] === c);
      if (any && any.sub) { const ps = $('.psub', sc) || $('#psub', sc); if (ps) ps.textContent = new DOMParser().parseFromString(any.sub, 'text/html').body.textContent; }
      const withImg = this.d.v.find((v) => v.o[this.ci] === c && v.m);
      if (withImg) {
        const gal = $('#gal', sc);
        if (gal) {
          const fig = $(`figure[data-media="${withImg.m}"]`, gal);
          if (fig && gal.firstElementChild !== fig) { fig.hidden = false; fig.classList.remove('more'); gal.prepend(fig); }
          gal.scrollTo && gal.scrollTo({ left: 0, behavior: 'smooth' });
        }
        const qi = $('.qv-imgs', sc);
        if (qi) { const im = $(`img[data-media="${withImg.m}"]`, qi); if (im) { qi.prepend(im); qi.scrollTo({ left: 0 }); } }
      }
    }
    refresh(user) {
      this.d.opts.forEach((o) => {
        if (o.i === this.ci) return;
        const g = $(`[data-opt="${o.i}"]`, this); if (!g) return;
        $$('[data-val]', g).forEach((b) => {
          const ok = this.d.v.some((v) => v.a && v.o[o.i] === b.dataset.val && this.d.opts.every((p) => p.i === o.i || this.sel[p.i] == null || v.o[p.i] === this.sel[p.i]));
          b.disabled = !ok;
          if (!ok && b.classList.contains('on')) { b.classList.remove('on'); b.setAttribute('aria-checked', 'false'); this.sel[o.i] = null; const lab = g.previousElementSibling && $('.oname', g.previousElementSibling); if (lab) lab.textContent = ''; }
        });
      });
      const v = this.variant();
      this.idIn.value = v ? v.id : '';
      const sc = this.scope;
      if (v) {
        $$('#pprice, .qv-price, #satc .card-p', sc.closest('[data-pdp]') ? document : sc).forEach((p) => (p.textContent = fmt(v.p)));
      }
      const soldAll = !this.d.v.some((x) => x.a);
      const sold = soldAll || (v && !v.a);
      if (this.btn) { this.btn.disabled = !!sold; this.btn.textContent = sold ? 'Agotado' : 'Agregar al carro'; }
      const satc = $('[data-satc]'); if (satc && this.dataset.mode === 'pdp') { satc.disabled = !!sold; satc.textContent = sold ? 'Agotado' : 'Agregar al carro'; }
      if (user && this.dataset.mode === 'pdp' && v) { try { history.replaceState(history.state, '', `${this.d.url}?variant=${v.id}`); } catch (e) {} }
    }
    missing() {
      const m = this.d.opts.find((o) => this.sel[o.i] == null && $(`[data-opt="${o.i}"]`, this));
      if (!m) return 'Elige una opción para agregarlo al carro.';
      return m.k === 'size' ? 'Elige tu talla para agregarlo al carro.' : m.k === 'color' ? 'Elige un color para agregarlo al carro.' : `Elige ${m.n.toLowerCase()} para agregarlo al carro.`;
    }
    async add() {
      const v = this.variant();
      if (!v) { if (this.err) this.err.textContent = this.missing(); const g = $('[data-opt] .size', this); g && g.closest('[data-opt]').scrollIntoView({ block: 'center', behavior: 'smooth' }); return; }
      if (!v.a) return;
      this.idIn.value = v.id;
      const fd = new FormData(this.form);
      fd.append('sections', cartSectionIds().join(','));
      fd.append('sections_url', location.pathname);
      this.btn.disabled = true; this.btn.classList.add('loading');
      try {
        const r = await fetch(R.cartAdd + '.js', { method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' } });
        const j = await r.json();
        if (j.status) { if (this.err) this.err.textContent = j.description || j.message || 'No pudimos agregarlo al carro.'; }
        else { renderCartSections(j.sections); openDrw('cart'); }
      } catch (e) { if (this.err) this.err.textContent = 'No pudimos agregarlo al carro. Revisa tu conexión e inténtalo de nuevo.'; }
      finally { this.btn.disabled = false; this.btn.classList.remove('loading'); this.refresh(false); }
    }
    query() {
      const v = this.variant(); const parts = [this.d.t];
      if (this.ci > -1 && this.sel[this.ci]) parts.push('color ' + this.sel[this.ci]);
      const si = this.d.opts.findIndex((o) => o.k === 'size'); if (si > -1 && this.sel[si]) parts.push('talla ' + this.sel[si]);
      return `Hola, quiero consultar por el ${parts.join(', ')}. ${location.origin}${this.d.url}${v ? '?variant=' + v.id : ''}`;
    }
  }
  if (!customElements.get('pys-product')) customElements.define('pys-product', PysProduct);

  async function quickView(h, c) {
    const qv = $('#qv'); if (!qv) return;
    try {
      const r = await fetch(`${root}products/${encodeURIComponent(h)}?section_id=pys-quick-view`);
      if (!r.ok) throw 0;
      qv.innerHTML = sectionInner(await r.text());
      const p = $('pys-product', qv);
      if (c && p) { const b = $(`[data-opt] [data-val="${CSS.escape(c)}"]`, p); if (b && !b.classList.contains('on')) b.click(); }
      openDrw('qv');
    } catch (e) { location.href = `${root}products/${encodeURIComponent(h)}`; }
  }

  /* ---------- ficha: galería, botón fijo, recomendaciones ---------- */
  let atcVisible = null;
  function stickyATC() {
    const s = $('#satc'); const a = $('#atc-main');
    if (!s || !a) return;
    const show = isMob() && atcVisible === false && a.getBoundingClientRect().top < 0;
    s.classList.toggle('on', show); s.setAttribute('aria-hidden', !show);
    const t = $('#top');
    document.documentElement.style.setProperty('--sticky-top', t && !t.classList.contains('hide') ? t.offsetHeight + 'px' : '0px');
  }
  function initPDP(scope = document) {
    const pdp = $('[data-pdp]', scope); if (!pdp) return;
    const a = $('#atc-main', pdp);
    if (a && 'IntersectionObserver' in window) new IntersectionObserver((es) => { atcVisible = es[0].isIntersecting; stickyATC(); }).observe(a);
    const g = $('#gal', pdp); const d = $('.gal-dots i', pdp);
    if (g) {
      const figs = $$('figure', g);
      if (isMob()) figs.forEach((f) => (f.hidden = false));
      if (d) d.style.width = 100 / Math.max(1, figs.length) + '%';
      g.addEventListener('scroll', () => { const w = g.scrollWidth - g.clientWidth; if (d && w > 0) d.style.left = (g.scrollLeft / w) * (100 - 100 / figs.length) + '%'; }, { passive: true });
    }
    const sw = $('.style-with[data-reco]', pdp);
    if (sw) loadMini(sw);
  }
  async function loadMini(sw) {
    const get = async (intent) => {
      try { const r = await fetch(`${sw.dataset.reco}&intent=${intent}`); if (!r.ok) return null; const d = parse(await r.text()); const m = d.querySelector('.reco-mini'); return m && m.children.length ? m : null; } catch (e) { return null; }
    };
    const m = (await get('complementary')) || (await get('related'));
    if (!m) return;
    const rail = $('.mini-rail', sw); rail.innerHTML = m.innerHTML; sw.hidden = false; initFavs(rail);
  }
  async function initRecoRails(scope = document) {
    for (const s of $$('[data-reco-rail]', scope)) {
      if ($('.rail', s)) continue;
      try {
        const r = await fetch(s.dataset.recoRail); if (!r.ok) continue;
        const d = parse(await r.text()); const src = d.querySelector('[data-reco-rail]');
        if (src && $('.rail', src)) { s.innerHTML = src.innerHTML; initFavs(s); } else s.hidden = true;
      } catch (e) {}
    }
  }

  /* ---------- compra el look ---------- */
  function initLook(scope = document) {
    $$('[data-look]', scope).forEach((sec) => {
      const tr = $('.look-r .look-track', sec); if (!tr) return;
      sec._p = 0;
      const upd = () => {
        const items = $$('.look-item', tr); const per = 2; const pages = Math.max(1, Math.ceil(items.length / per));
        sec._p = (sec._p + pages) % pages;
        items.forEach((it, i) => (it.hidden = Math.floor(i / per) !== sec._p));
        const pr = $('.look-prog i', sec); if (pr) { pr.style.width = 100 / pages + '%'; pr.style.left = (sec._p * 100) / pages + '%'; }
        const nav = $('.look-nav', sec); if (nav) nav.hidden = pages < 2;
      };
      sec._upd = upd; upd();
    });
  }

  /* ---------- guía de tallas ---------- */
  const toIn = (v) => v.split('–').map((x) => (parseFloat(x) / 2.54).toFixed(1)).join('–');
  let unit = 'cm';
  function sizeGuide() {
    const sel = $('#msz'); if (!sel) return;
    const o = sel.selectedOptions[0]; if (!o) return;
    const cv = (v) => (unit === 'cm' ? v + ' cm' : toIn(v) + ' pulg');
    const map = { b: ['Busto', o.dataset.b], w: ['Cintura', o.dataset.w], h: ['Cadera', o.dataset.h] };
    $$('#mdl dt').forEach((dt) => { const m = map[dt.dataset.k]; if (m) dt.textContent = `${m[0]}: ${cv(m[1])}`; });
  }
  function setUnit(u) {
    unit = u;
    $$('[data-unit]').forEach((b) => b.classList.toggle('on', b.dataset.unit === u));
    $$('.tbl-body td[data-cm]').forEach((td) => { const v = td.dataset.cm; td.textContent = u === 'cm' ? v : toIn(v); });
    sizeGuide();
  }

  /* ---------- preguntas frecuentes ---------- */
  function initFAQ() {
    const q = $('#faq-q'); if (!q) return;
    q.addEventListener('input', () => {
      const v = q.value.trim().toLowerCase(); let any = 0;
      $$('.faq-cat').forEach((sec) => {
        let n = 0;
        $$('details', sec).forEach((d) => { const m = !v || d.textContent.toLowerCase().includes(v); d.hidden = !m; if (m) { n++; any++; } if (v && m) d.open = true; });
        sec.hidden = !n;
      });
      const none = $('#faq-none'); if (none) none.hidden = !!any;
    });
    if (location.hash.startsWith('#faq-')) { const s = $(location.hash); if (s) { const d = $('details', s); if (d) d.open = true; } }
  }

  /* ---------- colección ---------- */
  function initCollection(scope = document) {
    const grid = $('#pgrid', scope); if (!grid) return;
    const key = isMob() ? 'cols-m' : 'cols-d';
    const saved = store.get(key, null);
    if (saved) setCols(saved, false);
    else markCols(isMob() ? 2 : +grid.dataset.colsDefault || 5);
  }
  function setCols(n, save = true) {
    const grid = $('#pgrid'); if (!grid) return;
    grid.style.setProperty('--cols', n); markCols(n);
    if (save) store.set(isMob() ? 'cols-m' : 'cols-d', n);
  }
  function markCols(n) { $$('[data-cols]').forEach((b) => b.classList.toggle('on', +b.dataset.cols === +n)); }
  async function loadMore(a) {
    const sec = a.closest('.shopify-section'); const id = sec && sec.id.replace('shopify-section-', '');
    if (!id) { location.href = a.href; return; }
    a.classList.add('loading'); a.setAttribute('aria-disabled', 'true');
    try {
      const u = new URL(a.href, location.origin); u.searchParams.set('section_id', id);
      const r = await fetch(u); if (!r.ok) throw 0;
      const d = parse(await r.text());
      const grid = $('#pgrid'); $$('#pgrid > .card', d).forEach((c) => grid.appendChild(c));
      const pm = $('#pmore'), npm = $('#pmore', d); if (pm && npm) pm.replaceWith(npm);
      initFavs(grid);
    } catch (e) { location.href = a.href; }
  }

  /* ---------- clics ---------- */
  document.addEventListener('click', (e) => {
    const t = e.target; let b;
    if ((b = t.closest('[data-close]'))) { e.preventDefault(); closeAll(); return; }
    if (t.id === 'veil') { closeAll(); return; }
    if (t.id === 'dim') { closeMega(); closeSearch(); return; }
    if ((b = t.closest('#mm-open'))) { openMM(); return; }
    if ((b = t.closest('[data-mmsub]'))) { const mm = $('#mm'); $('.mm-main', mm).hidden = true; $(`.mm-sub[data-sub="${b.dataset.mmsub}"]`, mm)?.classList.add('on'); return; }
    if (t.closest('[data-mmback]')) { const mm = $('#mm'); $('.mm-main', mm).hidden = false; $$('.mm-sub', mm).forEach((s) => s.classList.remove('on')); return; }
    if ((b = t.closest('#cart-open'))) { if (!location.pathname.endsWith('/cart')) { e.preventDefault(); openDrw('cart'); } return; }
    if ((b = t.closest('[data-qv]'))) { e.preventDefault(); quickView(b.dataset.qv, b.dataset.c); return; }
    if ((b = t.closest('[data-fav]'))) { e.preventDefault(); toggleFav(b.dataset.fav); return; }
    if ((b = t.closest('.card .sw button[data-c]'))) {
      e.preventDefault();
      const card = b.closest('.card'); const im = $('.card-img img.a', card);
      if (im && b.dataset.img) { im.src = b.dataset.img; if (b.dataset.set) im.srcset = b.dataset.set; }
      const s = $('.card-s', card); if (s && b.dataset.sub) s.textContent = new DOMParser().parseFromString(b.dataset.sub, 'text/html').body.textContent;
      if (b.dataset.href) $$('a.card-img, a.card-n', card).forEach((a) => (a.href = b.dataset.href));
      $$('.sw button', card).forEach((x) => x.classList.toggle('on', x === b));
      $$('[data-qv]', card).forEach((x) => (x.dataset.c = b.dataset.c));
      return;
    }
    if ((b = t.closest('[data-tab]'))) {
      const box = b.closest('[data-tabs]');
      $$('[data-tab]', box).forEach((x) => { x.classList.toggle('on', x === b); x.setAttribute('aria-selected', x === b); });
      $$('[data-panel]', box).forEach((p) => (p.hidden = p.dataset.panel !== b.dataset.tab));
      return;
    }
    if ((b = t.closest('[data-rail]'))) { const r = document.getElementById(b.dataset.rail); r && r.scrollBy({ left: +b.dataset.dir * (r.clientWidth - 64), behavior: 'smooth' }); return; }
    if ((b = t.closest('[data-mr]'))) { const r = document.getElementById('mr-' + b.dataset.mr); r && r.scrollBy({ left: +b.dataset.dir * r.clientWidth, behavior: 'smooth' }); return; }
    if ((b = t.closest('[data-look-go]'))) { const sec = b.closest('[data-look]'); sec._p += +b.dataset.lookGo; sec._upd && sec._upd(); return; }
    if ((b = t.closest('[data-look-m]'))) { const sec = b.closest('[data-look]'); const tpl = $('.look-tpl', sec); const qv = $('#qv'); qv.innerHTML = ''; qv.appendChild(tpl.content.cloneNode(true)); initFavs(qv); openDrw('qv'); return; }
    // colección
    if (t.closest('#f-open')) { openDrw('flt'); return; }
    if ((b = t.closest('#s-open'))) { const m = $('#sortm'); const on = !m.classList.contains('on'); m.classList.toggle('on', on); b.setAttribute('aria-expanded', on); return; }
    if ((b = t.closest('[data-sort]'))) { const u = new URL(location.href); u.searchParams.set('sort_by', b.dataset.sort); u.searchParams.delete('page'); location.href = u.toString(); return; }
    if ((b = t.closest('[data-cols]'))) { setCols(+b.dataset.cols); return; }
    if ((b = t.closest('[data-fg]'))) { const g = b.parentElement; g.classList.toggle('open'); const u = $('use', b); u && u.setAttribute('href', g.classList.contains('open') ? '#i-minus' : '#i-plus'); return; }
    if ((b = t.closest('a[data-next]'))) { e.preventDefault(); if (b.getAttribute('aria-disabled') !== 'true') loadMore(b); return; }
    if (!t.closest('#s-open') && !t.closest('#sortm')) $('#sortm')?.classList.remove('on');
    // ficha
    if (t.closest('[data-satc]')) {
      const p = $('[data-pdp] pys-product'); if (!p) return;
      if (!p.variant()) { if (p.err) p.err.textContent = p.missing(); $('#atc-main')?.scrollIntoView({ block: 'center', behavior: 'smooth' }); return; }
      p.add(); return;
    }
    if (t.closest('[data-sg]')) { const tpl = $('#sg-tpl'); if (tpl) { const qv = $('#qv'); qv.innerHTML = ''; qv.appendChild(tpl.content.cloneNode(true)); openDrw('qv'); } return; }
    if ((b = t.closest('[data-igq]'))) {
      const p = b.closest('pys-product'); const msg = p && p.query ? p.query() : '';
      if (msg && navigator.clipboard) { navigator.clipboard.writeText(msg).then(() => toast('Copiamos tu consulta: pégala en el chat de Instagram.')).catch(() => {}); }
      return;
    }
    if (t.closest('#gal-more')) { $$('#gal figure.more').forEach((f) => (f.hidden = false)); t.closest('.gal-more').remove(); return; }
    if ((b = t.closest('#gal img[data-zoom]'))) {
      if (!isMob()) { const z = $('#zoom'); z.innerHTML = `<button type="button" data-close aria-label="Cerrar"><svg class="ico" aria-hidden="true"><use href="#i-close"/></svg></button><img src="${b.dataset.zoom}" alt="${b.alt.replace(/"/g, '&quot;')}">`; z.classList.add('on'); document.body.style.overflow = 'hidden'; }
      return;
    }
    if ((b = t.closest('[data-unit]'))) { setUnit(b.dataset.unit); return; }
    // carro
    if ((b = t.closest('[data-rm]'))) { e.preventDefault(); cartChange(+b.dataset.rm, 0); return; }
  });
  document.addEventListener('change', (e) => {
    const t = e.target;
    if (t.matches('[data-qty]')) { cartChange(+t.dataset.qty, +t.value); return; }
    if (t.id === 'msz') sizeGuide();
  });
  document.addEventListener('submit', (e) => {
    const f = e.target;
    if (f.matches('.fform')) { $$('input[type=number]', f).forEach((i) => { if (i.value === '') i.disabled = true; }); }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { closeAll(); closeMega(); closeSearch(); $('#sortm')?.classList.remove('on'); } });

  /* ---------- inicio ---------- */
  function initAll(scope = document) {
    initFavs(scope); initLook(scope); initPDP(scope); initRecoRails(scope); initCollection(scope);
  }
  function boot() {
    initHeader(); favBadge(); initAll(); initFavPage(); initFAQ(); sizeGuide(); initStandardActions();
    cartBadge(window.PYS ? window.PYS.cartCount : 0);
    window.addEventListener('resize', () => updateTop(true), { passive: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  // Editor de temas: volver a iniciar la sección que cambió
  document.addEventListener('shopify:section:load', (e) => { if ($('#top', e.target)) initHeader(); initAll(e.target); initRotators(e.target); });
  document.addEventListener('shopify:block:select', (e) => {
    const sec = e.target.closest('[data-tabs]'); if (sec && e.target.matches('[data-tab]')) e.target.click();
    if (e.target.closest('.mega')) { const m = e.target.closest('.mega'); openMega(m.dataset.mega); }
  });
  document.addEventListener('shopify:block:deselect', () => closeMega());
})();
